import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Services', href: '#services', isPage: false },
    { label: 'Industries', href: '#industries', isPage: false },
    { label: 'Partners', href: '#partners', isPage: false },
    { label: 'Blog', href: '/blog', isPage: true },
    { label: 'Careers', href: '/careers', isPage: true },
    { label: 'About Us', href: '/about', isPage: true },
    { label: 'Contact', href: '/contact', isPage: true }
  ];

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6 mt-4'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 cursor-pointer" onClick={scrollToTop}>
            <span className={`text-[8px] sm:text-lg font-bold transition-colors whitespace-nowrap ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`} style={{ WebkitTextStroke: '0.5px black', paintOrder: 'stroke fill' }}>
              <span className="text-red-600">P</span>ATRIOT DEFENSE <span className="text-[#0066CC]">T</span>ECHNOLOGIES
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              item.isPage ? (
                <Link
                  key={item.label}
                  to={item.href}
                  className={`text-sm font-medium transition-colors hover:text-[#0066CC] whitespace-nowrap cursor-pointer ${
                    isScrolled ? 'text-gray-700' : 'text-white'
                  }`}
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => scrollToSection(e, item.href)}
                  className={`text-sm font-medium transition-colors hover:text-[#0066CC] whitespace-nowrap cursor-pointer ${
                    isScrolled ? 'text-gray-700' : 'text-white'
                  }`}
                >
                  {item.label}
                </a>
              )
            ))}
            <a 
              href="#booking"
              onClick={(e) => scrollToSection(e, '#booking')}
              className="px-6 py-2.5 bg-[#0066CC] text-white rounded-lg font-semibold text-sm hover:bg-[#0055AA] transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Appointment
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 py-4 bg-white rounded-2xl shadow-xl">
            <div className="flex flex-col space-y-1 px-4">
              {navItems.map((item) => (
                item.isPage ? (
                  <Link
                    key={item.label}
                    to={item.href}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <a
                    key={item.label}
                    href={item.href}
                    onClick={(e) => scrollToSection(e, item.href)}
                    className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                )
              ))}
              <a 
                href="#booking"
                onClick={(e) => scrollToSection(e, '#booking')}
                className="mx-4 mt-2 px-6 py-3 bg-[#0066CC] text-white rounded-lg font-semibold text-center hover:bg-[#0055AA] transition-colors cursor-pointer whitespace-nowrap"
              >
                Book Appointment
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
